import {emotionStyled, keyframes, tokens} from '@packages/utilities/styled';
import {avatarSizes} from '../Avatar';
import {SwitchKnobView, SwitchTrackView} from '../Switch/Switch.styles';
import {View} from '../View';

const pulse = keyframes({
  '0%': {
    opacity: 1,
  },
  '50%': {
    opacity: 0.5,
  },
  '100%': {
    opacity: 1,
  },
});

export const SkeletonSwitchTrackView = emotionStyled(SwitchTrackView)(
  {
    backgroundColor: '$skeleton',
    borderColor: '$border1',
  },
  {
    variants: {
      animation: {
        true: {
          animation: `${pulse} 2100ms ease-in-out 500ms infinite`,
        },
      },
    },
  }
);

export const SkeletonSwitchKnobView = emotionStyled(SwitchKnobView)({
  backgroundColor: '$skeleton',
  boxShadow: 'none',
});

export const SkeletonView = emotionStyled(View)(
  {
    backgroundColor: '$skeleton',
    borderRadius: '$2',
    opacity: 1,
  },
  {
    componentName: 'Skeleton',
    variants: {
      animation: {
        true: {
          animation: `${pulse} 2100ms ease-in-out 500ms infinite`,
        },
      },
      isRounded: {
        true: {
          borderRadius: '$rounded',
        },
      },
      variant: {
        avatar: {
          borderRadius: '$rounded',
          height: avatarSizes.medium,
          width: avatarSizes.medium,
        },
        control: {
          height: 'auto',
          lineHeight: tokens.typography.lineHeight.body,
          padding: tokens.ui.button.padding.compact,
          width: 100,
          /**
           * The following is a hack to hide text within the Skeleton.
           *
           * Context:
           * We're using the Button component's lineHeight and padding
           * to maintain parity with the Button's styling. In order
           * for lineHeight to render, there needs to be text
           * present. We're using a pseudo element to hide the text.
           *  */
          '&::before': {
            content: '"control"',
            opacity: 0,
            visibility: 'hidden',
            pointerEvents: 'none',
          },
        },
        text: {
          height: tokens.typography.fontSize.body,
        },
        title: {
          height: tokens.typography.fontSize.title,
        },
      },
    },
  }
);
